// ServicesSection.js
import React from 'react';
import { motion } from 'framer-motion';

const ServicesSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block bg-[#F5F8FA] text-[#2542D4] text-sm font-light px-6 py-2 rounded-full mb-4">
              Our Services
            </span>
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356]">
              Global Mobility Solutions
            </h2>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="flex items-center"
          >
            <p className="text-gray-600 text-sm font-light leading-relaxed">
              Notapaths provides structured global mobility support for individuals seeking to study or work abroad. Through personalised consultations, practical guidance, and end-to-end application support, we help clients navigate international opportunities with clarity, preparation, and confidence.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
